import { createReducer } from '@reduxjs/toolkit';

import { retryRequest } from 'Core/actions/request';
import { setResponse } from 'Core/actions/response';

const initState = 0;

export default createReducer(initState, (builder) =>
  builder
    .addCase(retryRequest, (state) => state + 1)
    .addCase(setResponse, (state, { payload }) =>
      state && payload.State === 'timeout' ? state + 1 : initState,
    ),
);
